
/* global BigInt */

import React, { createContext, useContext, useState } from "react";
import { AuthClient } from "@dfinity/auth-client";
import { Principal } from '@dfinity/principal';
// import { gatewayUrl, icUrl } from "./ws.config.js";
// import { canisterId, pleximail_backend/*, createActor*/ } from "../declarations/pleximail_backend";
// import { /*canisterId, pleximail_backend,*/ createActor } from "../declarations/pleximail_identity";

import {PlexiMailService} from "./PlexiMailService.js";
import { initializePlexiMailServiceClient, intializeIndexClient } from "./client.js";
import { PlexiIdentityService } from "./PlexiIdentityService.js";
import { createIdentityActor } from "./actor.js";
import { SetupWizardState } from "../utils/Types.js";
import ContractBackupService from "../components/contract/ContractBackupService.js";

import {DelegationIdentity, Ed25519PublicKey, ECDSAKeyIdentity, Ed25519KeyIdentity, DelegationChain, Delegation} from "@dfinity/identity";
import { HttpAgent } from "@dfinity/agent";
import { IdbKeyVal } from '@dfinity/auth-client/lib/cjs/db.js'; // 导入 IdbStorage



// const indexClient = intializeIndexClient(true);
// const plexiMailServiceClient = initializePlexiMailServiceClient(true, indexClient);


var authClient = await AuthClient.create({keyType: 'ECDSA', idleOptions: {disableIdle: true}});
// var authClient = null;


const initialContext = {
  identity: null,
  isAuthenticated: false,
  plexiMailService: null,
  login: () => {
    throw new Error("login function must be overridden");
  },
  logout: async () => {
    throw new Error("logout function must be overridden");
  },
  checkAuth: () => {
    throw new Error("checkAuth function must be overridden");
  },
  handleIIDelegation: () => {
    throw new Error("handleIIDelegation function must be overridden");
  },
};

const ContextWrapper = createContext(initialContext);

export const useAuth = () => {
  return useContext(ContextWrapper);
};

const ICPAuthProvider = ({ children }) => {
  const [identity, setIdentity] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [plexiMailService, setPlexiMailService] = useState(null);
  const [plexiIdentityService, setPlexiIdentityService] = useState(null);
// console.log(process.env);
  
  const login = async () => {

    const result = {
      promise: null,
      resolve: null,
      reject: null
    };

    result.promise = new Promise((resolve, reject) => {
      result.resolve = resolve;
      result.reject = reject;
    });
    let identityProvider = localStorage.getItem('app.ii.url');
    if (!identityProvider || identityProvider.length === 0) {
      identityProvider = process.env.DFX_NETWORK === 'ic'
      ? 'https://identity.ic0.app/#authorize'
      : `http://${process.env.CANISTER_ID_INTERNET_IDENTITY}.localhost:4943/#authorize`; 
    }
    if (process.env.DFX_NETWORK === 'ic') {
      // identityProvider = "https://7uvlp-gyaaa-aaaak-apbtq-cai.icp0.io/#authorize";
      identityProvider = "https://id.ai/#authorize";
    }
    // authClient = await AuthClient.create({keyType: 'Ed25519', idleOptions: {disableIdle: true}});
    // if (!authClient) {
    //   authClient = await AuthClient.create({keyType: 'ECDSA', idleOptions: {disableIdle: true}});
    // }
    // BigInt(8) hours * BigInt(3_600_000_000_000
    await authClient.login({
      maxTimeToLive: BigInt(196) * BigInt('3600000000000'),
      identityProvider: identityProvider,
    //   identityProvider: process.env.DFX_NETWORK === 'ic'
    //     ? 'https://identity.ic0.app/#authorize'
    //     : `http://${process.env.CANISTER_ID_INTERNET_IDENTITY}.localhost:4943/#authorize`,
    // // `http://localhost:8000?canisterId=${process.env.INTERNET_IDENTITY_CANISTER_ID}#authorize`,
      windowOpenerFeatures: `left=${window.screen.width / 2 - 525 / 2}, top=${window.screen.height / 2 - 705 / 2},toolbar=0,location=0,menubar=0,width=550,height=705`,
      onSuccess: () => {
        checkAuth(true).then(() => {
          result.resolve();
        }).catch(e => {
          result.reject(e);
        })
      },
      onError: (err) => {
        result.reject(err);
      },
    });
    
    let oldPrincipal = localStorage.getItem('app.recent-ii');

    await result.promise;

    if (await authClient.isAuthenticated()) {
      const _identity = authClient.getIdentity();
      setIdentity(_identity);

      const principal = _identity.getPrincipal().toString();

      
      if (window.appConfig.setupWizardState !== SetupWizardState.ConnectWallet && oldPrincipal && oldPrincipal.length > 0 && oldPrincipal !== principal) {
        await logout();
        throw new Error('Internet Identity Mismatch.');
      }
    }
  };

  const handleIIDelegation = async function(encodedData) {

    // const data = JSON.parse(decodeURIComponent(encodedData));

    // // 重建 userPublicKey
    // const userPublicKey = Uint8Array.fromHex(data.userPublicKeyHex);

    // // delegations 是 signed_delegations 数组 (从 II 返回)
    // const delegations = data.delegations.map(del => ({
    //     delegation: {
    //         pubkey: new Uint8Array(del.delegation.pubkey),
    //         expiration: BigInt(del.delegation.expiration),
    //         targets: del.delegation.targets ? del.delegation.targets.map(Principal.fromText) : undefined
    //     },
    //     signature: new Uint8Array(del.signature)
    // }));

    

    const delegations = encodedData.delegations.map(signedDelegation => {
        return {
            delegation: new Delegation(signedDelegation.delegation.pubkey, signedDelegation.delegation.expiration, signedDelegation.delegation.targets),
            signature: signedDelegation.signature.buffer,
        };
    });

    const delegationChain = DelegationChain.fromDelegations(delegations, encodedData.userPublicKey);

    // 从临时存储恢复 sessionKey
    // const tempKeyJSON = sessionStorage.getItem('tempSessionKey');
    // if (!tempKeyJSON) {
    //     console.error('Session key not found');
    //     return;
    // }
    // const sessionKey = Ed25519KeyIdentity.fromJSON(tempKeyJSON);
    // const sessionKey = await ECDSAKeyIdentity.fromKeyPair(tempKeyJSON);

    const storage = await IdbKeyVal.create();
    const kp = await storage.get('identity');
    const sessionKey = await ECDSAKeyIdentity.fromKeyPair(kp);
    console.log(sessionKey);

    // 创建 DelegationIdentity
    const identity = DelegationIdentity.fromDelegation(sessionKey, delegationChain);

    // 存储到 IndexedDB，像 auth-client 一样
    await storage.set('delegation', JSON.stringify(delegationChain.toJSON()));
    // await storage.set('identity', JSON.stringify(sessionKey.toJSON()));


    console.log('Delegation stored, identity principal:', identity.getPrincipal().toText());

    // 继续 app 逻辑，例如创建 authClient 并使用
    // const authClient = await AuthClient.create({keyType: 'Ed25519'});
    authClient = await AuthClient.create({keyType: 'ECDSA'});
    const storedIdentity = authClient.getIdentity();
    console.log('From authClient:', storedIdentity.getPrincipal().toText());
    // 这里你可以调用 canister 等


    let oldPrincipal = localStorage.getItem('app.recent-ii');

    if (await authClient.isAuthenticated()) {
      const _identity = authClient.getIdentity();
      setIdentity(_identity);

      const principal = _identity.getPrincipal().toString();

      
      if (window.appConfig.setupWizardState !== SetupWizardState.ConnectWallet && oldPrincipal && oldPrincipal.length > 0 && oldPrincipal !== principal) {
        await logout();
        throw new Error('Internet Identity Mismatch.');
      }
    }
  };
  
  const loginForIOSApp = async () => {

    const result = {
      promise: null,
      resolve: null,
      reject: null
    };

    result.promise = new Promise((resolve, reject) => {
      result.resolve = resolve;
      result.reject = reject;
    });
    let identityProvider = localStorage.getItem('app.ii.url');
    if (!identityProvider || identityProvider.length === 0) {
      identityProvider = process.env.DFX_NETWORK === 'ic'
      ? 'https://identity.ic0.app/#authorize'
      : `http://${process.env.CANISTER_ID_INTERNET_IDENTITY}.localhost:4943/#authorize`; 
    }
    if (process.env.DFX_NETWORK === 'ic') {
      identityProvider = "https://7uvlp-gyaaa-aaaak-apbtq-cai.icp0.io/#authorize";
    }
    // BigInt(8) hours * BigInt(3_600_000_000_000
    await authClient.login({
      maxTimeToLive: BigInt(196) * BigInt('3600000000000'),
      identityProvider: identityProvider,
    //   identityProvider: process.env.DFX_NETWORK === 'ic'
    //     ? 'https://identity.ic0.app/#authorize'
    //     : `http://${process.env.CANISTER_ID_INTERNET_IDENTITY}.localhost:4943/#authorize`,
    // // `http://localhost:8000?canisterId=${process.env.INTERNET_IDENTITY_CANISTER_ID}#authorize`,
      windowOpenerFeatures: `left=${window.screen.width / 2 - 525 / 2}, top=${window.screen.height / 2 - 705 / 2},toolbar=0,location=0,menubar=0,width=550,height=705`,
      onSuccess: () => {
        checkAuth(true).then(() => {
          result.resolve();
        }).catch(e => {
          result.reject(e);
        })
      },
      onError: (err) => {
        result.reject(err);
      },
    });
    
    let oldPrincipal = localStorage.getItem('app.recent-ii');

    await result.promise;

    if (await authClient.isAuthenticated()) {
      const _identity = authClient.getIdentity();
      setIdentity(_identity);

      const principal = _identity.getPrincipal().toString();

      
      if (window.appConfig.setupWizardState !== SetupWizardState.ConnectWallet && oldPrincipal && oldPrincipal.length > 0 && oldPrincipal !== principal) {
        await logout();
        throw new Error('Internet Identity Mismatch.');
      }
    }
  };



  const checkAuth = async (createIfNeeded=false) => {
    try {
      if (!authClient) {
        // authClient = await AuthClient.create({keyType: 'Ed25519', idleOptions: {disableIdle: true}});
        authClient = await AuthClient.create({keyType: 'ECDSA', idleOptions: {disableIdle: true}});
      }
      if (await authClient.isAuthenticated()) {

        setIsAuthenticated(true);

        const _identity = authClient.getIdentity();
        setIdentity(_identity);


        const principal = _identity.getPrincipal().toString();

        let oldPrincipal = localStorage.getItem('app.recent-ii');
        
        if (window.appConfig.setupWizardState !== SetupWizardState.ConnectWallet && oldPrincipal && oldPrincipal.length > 0 && oldPrincipal !== principal) {
          await logout();
          throw new Error('Internet Identity Mismatch.');
        }
        
        const group = window.appConfig.domainName;// "ai-fi.cc";
        
        // // set backend actor
        // const _backendActor = createActor({
        //   agentOptions: {
        //     identity: _identity,
        //   },
        // });


        
        // // set websocket client
        // const _ws = new IcWebSocket(gatewayUrl, undefined, {
        //   canisterId: canisterId,
        //   canisterActor: pleximail_backend,
        //   identity: _identity,
        //   networkUrl: icUrl,
        // });
        // setWs(_ws);
        let isLocal = process.env.DFX_NETWORK === 'local';
        const indexClient = intializeIndexClient(isLocal, _identity);
        const plexiMailServiceClient = initializePlexiMailServiceClient(isLocal, _identity, indexClient);

        // const group = "ai-fi.cc";
        
        const _plexiMailService = new PlexiMailService(principal, group, indexClient, plexiMailServiceClient);
        if (createIfNeeded) {
          try {
            await _plexiMailService.createCanisterByGroupIfNeeded();
          } catch (e) {
            console.error(e);
            throw e;
          }
        }

        setPlexiMailService(_plexiMailService);

        window.plexiMailService = _plexiMailService;
        localStorage.setItem('app.recent-ii', _plexiMailService.getPrincipal());
        // window.icpWs = _ws;
        // handleWs(_ws);

        // window.icpWsOpts = {
        //   url: gatewayUrl, 
        //   protocols: null, 
        //   config: {
        //     canisterId: canisterId,
        //     canisterActor: pleximail_backend,
        //     identity: _identity,
        //     networkUrl: icUrl,
        //   }
        // };
        
        const identityActor = createIdentityActor(process.env.CANISTER_ID_PLEXIMAIL_IDENTITY, {
          agentOptions: {
            identity: _identity,
          },
        });
        const _plexiIdentityService =  new PlexiIdentityService(identityActor);
        setPlexiIdentityService(_plexiIdentityService);
        window.plexiIdentityService = _plexiIdentityService;
        const _contractBackupService = new ContractBackupService();
        window.contractBackupService = _contractBackupService;
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error in checkAuth", error);
      return false;
    }
  };

  const logout = async () => {
    console.log('---- Log out Internet Identity');
    await authClient.logout();
    setIsAuthenticated(false);
    setIdentity(null);
  };

  return (
    <ContextWrapper.Provider
      value={{
        identity,
        isAuthenticated,
        plexiMailService,
        login,
        logout,
        checkAuth,
        handleIIDelegation,
      }}
    >
      {children}
    </ContextWrapper.Provider>
  );
};

export default ICPAuthProvider;
